import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const TransactionStatusChart = ({ data }) => {
  if (!data) return null;

  const chartOptions = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Transaction Status Distribution",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b><br/>Count: <b>{point.y}</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
        showInLegend: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Transactions",
        colorByPoint: true,
        data: [
          {
            name: "Completed",
            y: data.completed || 0,
            color: "#52c41a",
          },
          {
            name: "Pending",
            y: data.pending || 0,
            color: "#faad14",
          },
          {
            name: "Failed",
            y: data.failed || 0,
            color: "#ff4d4f",
          },
        ],
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default TransactionStatusChart;
